import React from 'react'
import { VStack, Separator, RadioGroup, VisuallyHidden } from '@chakra-ui/react'
import { CreditCardOption } from './CreditCardOption'
import { PayPayOption } from './PayPayOption'

export const PaymentMethodSelector = ({ selectedMethod, onMethodChange }) => (
  <RadioGroup.Root size="lg" colorPalette="red" value={selectedMethod} onValueChange={(e) => onMethodChange(e.value)}>
    <VStack w="100%" gap={0} bg="white" borderRadius="4px" border="1px solid" borderColor="divider.light">
      <RadioGroup.Item value="credit_card" w="100%" p="16px" display="flex" alignItems="flex-start" gap={3} cursor="pointer">
        <RadioGroup.ItemHiddenInput />
        <RadioGroup.ItemIndicator mt="2px" />
        <RadioGroup.ItemText>
          <VisuallyHidden>クレジットカード</VisuallyHidden>
          <CreditCardOption />
        </RadioGroup.ItemText>
      </RadioGroup.Item>
      <Separator w="100%" />
      <RadioGroup.Item value="paypay" w="100%" p="16px" display="flex" alignItems="center" gap={3} cursor="pointer">
        <RadioGroup.ItemHiddenInput />
        <RadioGroup.ItemIndicator />
        <RadioGroup.ItemText>
          <VisuallyHidden>PayPay</VisuallyHidden>
          <PayPayOption />
        </RadioGroup.ItemText>
      </RadioGroup.Item>
    </VStack>
  </RadioGroup.Root>
)
